import React from "react";
import { MapPin, Phone, Mail, Clock, ArrowRight } from "lucide-react";
import Reveal from "../Reveal";
import StoreMap from "../StoreMap";
import { InstagramIcon, YoutubeIcon } from "../BrandIcons";
import {
  WHATSAPP_NUMBER,
  WHATSAPP_NUMBER_2,
  CONTACT_EMAIL,
  INSTAGRAM_URL,
  INSTAGRAM_HANDLE,
  YOUTUBE_URL,
  YOUTUBE_HANDLE,
} from "../../lib/api";
import { stores } from "../../lib/home-content";

const VisitSection = () => (
  <section id="showroom" className="bg-[#F4F7FE] scroll-mt-24">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <div className="overline">Come Visit Us</div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-light mt-4 leading-[1.05] text-[#0F1245]">
            Lajpat Nagar,<br /><span className="italic text-[#4A3FCF]">New Delhi.</span>
          </h2>
          <p className="mt-6 text-[15px] text-[#5A5F7A] leading-relaxed max-w-md">
            Two showrooms on the same block. Walk in to feel the fabric, meet the design desk, and finalise your order over a cup of chai.
          </p>

          <div className="mt-10 space-y-6">
            <div className="flex gap-4">
              <Phone size={20} strokeWidth={1.5} className="text-[#4A3FCF] mt-1 shrink-0" />
              <div>
                <div className="overline">Call &amp; WhatsApp</div>
                <a href={`tel:+${WHATSAPP_NUMBER}`} data-testid="contact-phone-link" className="font-serif-display text-2xl mt-1 block text-[#0F1245] hover:text-[#4A3FCF] transition-colors">+91 97118 84840</a>
                <a href={`tel:+${WHATSAPP_NUMBER_2}`} data-testid="contact-phone-link-2" className="font-serif-display text-2xl mt-1 block text-[#0F1245] hover:text-[#4A3FCF] transition-colors">+91 98113 37753</a>
              </div>
            </div>

            <div className="flex gap-4">
              <Mail size={20} strokeWidth={1.5} className="text-[#4A3FCF] mt-1 shrink-0" />
              <div>
                <div className="overline">Email</div>
                <a href={`mailto:${CONTACT_EMAIL}`} data-testid="contact-email-link" className="font-serif-display text-xl mt-1 block text-[#0F1245] hover:text-[#4A3FCF] transition-colors">{CONTACT_EMAIL}</a>
              </div>
            </div>

            <div className="flex gap-4">
              <InstagramIcon size={20} className="mt-1 shrink-0" />
              <div>
                <div className="overline">Instagram</div>
                <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="contact-instagram-link" className="font-serif-display text-xl mt-1 block text-[#0F1245] hover:text-[#4A3FCF] transition-colors">{INSTAGRAM_HANDLE}</a>
              </div>
            </div>

            <div className="flex gap-4">
              <YoutubeIcon size={20} className="mt-1 shrink-0" />
              <div>
                <div className="overline">YouTube</div>
                <a href={YOUTUBE_URL} target="_blank" rel="noreferrer" data-testid="contact-youtube-link" className="font-serif-display text-xl mt-1 block text-[#0F1245] hover:text-[#4A3FCF] transition-colors">{YOUTUBE_HANDLE}</a>
              </div>
            </div>

            <div className="flex gap-4">
              <Clock size={20} strokeWidth={1.5} className="text-[#4A3FCF] mt-1 shrink-0" />
              <div>
                <div className="overline">Open Hours</div>
                <p className="font-serif-display text-xl mt-1 text-[#0F1245] leading-snug">Tuesday — Sunday<br />10:00 AM – 8:00 PM</p>
                <p className="text-[12px] tracking-widest uppercase text-[#5A5F7A] mt-1">Closed on Mondays</p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal className="lg:col-span-7" delay={150}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            {stores.map((s, i) => (
              <div key={s.tag} data-testid={`store-${i}`} className="bg-white border border-[#DCE4F2] p-7 md:p-8">
                <MapPin size={20} strokeWidth={1.5} className="text-[#4A3FCF]" />
                <div className="overline mt-4">{s.tag}</div>
                <p className="font-serif-display text-lg md:text-xl mt-2 text-[#0F1245] leading-snug">{s.addr}</p>
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${s.mapQ}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`store-${i}-directions`}
                  className="mt-5 inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-medium text-[#4A3FCF] hover:underline underline-offset-4"
                >
                  Get directions <ArrowRight size={14} />
                </a>
              </div>
            ))}
          </div>

          <div className="aspect-[16/9] w-full border border-[#DCE4F2] overflow-hidden bg-[#F4F7FE]">
            <StoreMap
              stores={stores.map((s) => ({
                label: s.label,
                lat: s.lat,
                lng: s.lng,
                sub: s.tag,
              }))}
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default VisitSection;
